import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/")({
  loader: async ({ params, parentMatchPromise }) => {
    const parentMatch = await parentMatchPromise
    if (parentMatch.fullPath === "/procurement/supply-plan/noos/$supplyPlanId") {
      throw redirect({
        to: "/procurement/supply-plan/noos/$supplyPlanId/overview",
        params,
        search: parentMatch.search,
      })
    }
    return null
  },
})
